import React, { createContext, useState, useContext, useEffect } from "react";
import { useHttpClient } from "../hooks/http-hook";
import { useParams } from "react-router-dom";

const ModuleContext = createContext();

export const ModuleProvider = ({ children }) => {
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(Date.now());
  const { sendRequest } = useHttpClient();
  const { moduleId } = useParams();

  const fetchModule = async () => {
    try {
      setLoading(true);
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}modules/${moduleId}`
      );

      const moduleData = response.module;

      const formattedModule = {
        ...moduleData,
        sections: (moduleData.sections || [])
          .filter((section) => !section.is_deleted)
          .map((section) => ({
            id: section._id,
            title: section.title,
            is_visible: section.is_visible,
            module: section.module,
            lessons: (section.lessons || [])
              .filter((lesson) => !lesson.is_deleted)
              .map((lesson) => ({
                id: lesson._id,
                title: lesson.title,
                is_visible: lesson.is_visible,
                type: lesson.type,
                is_deleted: lesson.is_deleted,
              })),
          })),
      };

      setModule(formattedModule);
    } catch (err) {
      console.error("Error fetching module:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moduleId) {
      fetchModule();
    }
  }, [moduleId, lastUpdate]);

  const refreshModule = () => {
    setLastUpdate(Date.now());
  };

  return (
    <ModuleContext.Provider value={{ module, loading, refreshModule }}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleContext = () => useContext(ModuleContext);
